var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysPencil = function SvgSysPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.203 11.797 2.025-.543a.025.025 0 0 0 .013-.007l7.451-7.451a1.053 1.053 0 0 0-1.488-1.489l-7.45 7.451a.026.026 0 0 0-.008.013l-.543 2.026Zm-.69 1.2a.514.514 0 0 1-.494-.646l.757-2.839c.047-.174.139-.333.266-.461L8.493 1.6a2.053 2.053 0 1 1 2.9 2.9L3.95 11.954c-.127.128-.286.22-.46.266l-2.842.761a.517.517 0 0 1-.135.018v-.002Z"
  })));
};
export default SvgSysPencil;